<template>
	<symbol :id="`${prefix}gear`" viewBox="0 0 21 21">
		<path
			:fill="getColor('main')"
			stroke="none"
			d="M10.5,7.64c-1.58,0-2.86,1.28-2.86,2.86s1.28,2.86,2.86,2.86s2.86-1.28,2.86-2.86S12.08,7.64,10.5,7.64z M10.5,12.41c-1.05,0-1.91-0.86-1.91-1.91c0-1.05,0.86-1.91,1.91-1.91c1.05,0,1.91,0.86,1.91,1.91 C12.41,11.55,11.55,12.41,10.5,12.41z"
		/>
		<path
			:fill="getColor('main')"
			stroke="none"
			d="M20.88,9.73c-0.3-0.95-1.27-1.62-2.35-1.62h-0.2c-0.34,0-0.65-0.21-0.79-0.54c-0.13-0.32-0.06-0.68,0.18-0.92 l0.14-0.14c0.76-0.76,0.97-1.92,0.51-2.8C18.01,3,17.37,2.52,16.6,2.4c-0.75-0.12-1.52,0.13-2.05,0.67l-0.2,0.2 c-0.24,0.24-0.6,0.31-0.94,0.17c-0.32-0.13-0.53-0.44-0.53-0.78v-0.2c0-1.08-0.67-2.04-1.62-2.35C10.51-0.12,9.72,0,9.09,0.46 C8.48,0.91,8.11,1.63,8.11,2.39v0.28c0,0.34-0.21,0.65-0.54,0.79C7.25,3.58,6.89,3.51,6.65,3.27L6.51,3.13 C5.74,2.37,4.59,2.16,3.7,2.62C3,2.98,2.52,3.63,2.4,4.4C2.29,5.15,2.54,5.91,3.08,6.45l0.2,0.2c0.24,0.24,0.31,0.6,0.17,0.94 C3.31,7.91,3.01,8.11,2.67,8.11h-0.2c-1.08,0-2.04,0.67-2.35,1.62c-0.24,0.76-0.12,1.55,0.34,2.18c0.45,0.61,1.17,0.98,1.93,0.98 h0.28c0.34,0,0.65,0.21,0.79,0.54c0.13,0.32,0.06,0.68-0.18,0.92l-0.14,0.14c-0.76,0.76-0.97,1.92-0.51,2.8 C2.99,18,3.63,18.48,4.4,18.6c0.75,0.12,1.52-0.14,2.05-0.67l0.2-0.2c0.24-0.24,0.6-0.31,0.94-0.17c0.32,0.13,0.53,0.44,0.53,0.78 v0.2c0,1.08,0.67,2.04,1.62,2.35C9.99,20.96,10.25,21,10.5,21c0.5,0,0.99-0.16,1.41-0.46c0.61-0.45,0.98-1.17,0.98-1.93v-0.28 c0-0.34,0.21-0.65,0.54-0.79c0.32-0.13,0.68-0.06,0.92,0.18l0.14,0.14c0.76,0.76,1.92,0.97,2.81,0.51c0.71-0.37,1.18-1.02,1.3-1.78 c0.12-0.75-0.14-1.52-0.67-2.05l-0.2-0.2c-0.24-0.24-0.31-0.6-0.17-0.94c0.13-0.32,0.44-0.53,0.78-0.53h0.28 c0.76,0,1.48-0.37,1.93-0.98C21,11.28,21.12,10.49,20.88,9.73z M19.77,11.34c-0.27,0.37-0.7,0.59-1.16,0.59h-0.28 c-0.73,0-1.38,0.44-1.67,1.13c-0.28,0.68-0.13,1.45,0.39,1.96l0.2,0.2c0.32,0.32,0.47,0.78,0.4,1.23c-0.07,0.46-0.36,0.85-0.8,1.08 c-0.52,0.27-1.22,0.13-1.69-0.34l-0.14-0.14c-0.51-0.51-1.28-0.67-1.98-0.38c-0.68,0.28-1.12,0.93-1.12,1.66v0.28 c0,0.45-0.22,0.89-0.59,1.16c-0.37,0.27-0.86,0.35-1.32,0.2c-0.56-0.18-0.95-0.77-0.95-1.44v-0.2c0-0.73-0.44-1.38-1.13-1.67 c-0.23-0.09-0.46-0.14-0.69-0.14c-0.47,0-0.92,0.18-1.27,0.52l-0.2,0.2c-0.32,0.32-0.78,0.47-1.23,0.4 c-0.46-0.07-0.85-0.36-1.08-0.8c-0.27-0.52-0.13-1.22,0.34-1.69l0.14-0.14c0.51-0.51,0.67-1.28,0.38-1.98 c-0.28-0.68-0.93-1.12-1.66-1.12H2.39c-0.45,0-0.89-0.22-1.16-0.59c-0.27-0.37-0.35-0.86-0.2-1.32C1.21,9.46,1.8,9.07,2.47,9.07 h0.2c0.73,0,1.38-0.44,1.67-1.13c0.28-0.68,0.13-1.45-0.39-1.96l-0.2-0.2c-0.32-0.32-0.47-0.78-0.4-1.23 c0.07-0.46,0.36-0.85,0.79-1.08c0.52-0.27,1.22-0.13,1.69,0.34l0.14,0.14c0.52,0.51,1.29,0.67,1.98,0.38 C8.63,4.05,9.07,3.4,9.07,2.67V2.39c0-0.45,0.22-0.89,0.59-1.16c0.38-0.27,0.86-0.35,1.32-0.2c0.56,0.18,0.95,0.77,0.95,1.44v0.2 c0,0.73,0.44,1.38,1.13,1.67c0.68,0.28,1.44,0.13,1.96-0.39l0.2-0.2c0.32-0.32,0.78-0.47,1.23-0.4c0.46,0.07,0.85,0.36,1.08,0.79 c0.27,0.52,0.13,1.22-0.34,1.69l-0.14,0.14c-0.51,0.51-0.67,1.28-0.38,1.98c0.28,0.68,0.93,1.12,1.66,1.12h0.2 c0.67,0,1.26,0.39,1.44,0.95C20.12,10.49,20.05,10.97,19.77,11.34z"
		/>
	</symbol>
</template>

<script>
export default {
	name: 'NiIconGear',


	props: {
		icon: {
			type: String,
		},

		prefix: {
			type: String,
			required: true,
		},

		palette: {
			type: Object,
		},

		disabled: {
			type: Boolean,
			default: false,
		},
	},


	computed: {
		colors() {
			return {
				main: this.$palette.darkgray,
				main__disabled: this.$palette.darkgray__disabled,

				...this.palette,
			};
		},
	},


	methods: {
		getColor(color) {
			let bits = [
				color,
			];

			if (this.disabled) {
				bits.push('disabled');
			}

			return this.colors[bits.join('__')];
		},
	},
};
</script>
